import { Routes } from '@angular/router';
import { authGuard } from './app/core';
import { maintenanceGuard } from './app/core/guard/maintenance.guard';
import { pagesRoutes } from './app/pages/pages.routes';

export const appRoutes: Routes = [
    { path: 'policies', loadComponent: () => import('./app/pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent) },
    { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },

    // Ruta pública directa para reset de contraseña
    { path: 'reset-password', loadComponent: () => import('./app/pages/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent) },

    {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
    },
    {
        path: 'sections',
        loadComponent: () => import('./app/pages/sections/sections.component').then(m => m.SectionsComponent),
        canActivate: [authGuard, maintenanceGuard]
    },
    ...pagesRoutes
];
